/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { noop } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'src/app/store';
import { useNavigate } from 'react-router-dom';
import { Modal } from '@dsny/dsny-component-library';
import { trackModalView } from 'src/utils/segmentService';
import {
  FlexButtonWrapper,
  ModalGoToDashboardButton,
  ModalPurchaseSucessBody,
  ModalPurchaseSucessHeading,
} from './Purchase.styles';
import { resetStateAddPayment } from './AddPayment';
import { AddTrackList, resetStateAddTrack } from './MultiAsset';
import { resetStateSelectPackage } from './SelectPackage';
import {
  clearSongSelection,
  resetStateDashBoard,
  TrackingStatusEnum,
} from '../Dashboard';

export const PurchaseSuccessModal = ({ show, setShowSuccess }: any) => {
  const { t } = useTranslation();

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { tracks }: AddTrackList = useSelector(
    (state: RootState) => state.multiAsset
  );

  const { selectedSong } = useSelector(
    (state: RootState) => state.dashboard.songSelection
  );

  const { enterpriseProfile } = useSelector(
    (state: RootState) => state.dashboard
  );

  const handleSuccessModal = () => {
    dispatch(resetStateAddPayment());
    dispatch(resetStateAddTrack());
    dispatch(resetStateSelectPackage());
    dispatch(clearSongSelection());
    dispatch(resetStateDashBoard());
    setShowSuccess(false);
    navigate('/dashboard');
  };

  // Getting modal text based on 3 scenarios (Renewal - Extension - Default)
  const modalText = () => {
    /* Renew state - expired past 90 day period */
    if (
      !tracks ||
      (tracks.length === 0 &&
        selectedSong?.selected_tracking_period.status ===
          TrackingStatusEnum.PAST_EXPIRED)
    ) {
      return (
        <Trans
          i18nKey="PURCHASE_SUCESS_MODAL_RENEW_DESC"
          values={{ song: selectedSong?.title }}
          components={{ bold: <strong /> }}
        />
      );
    }

    /* Extend state - within 90 day period */
    if (!tracks || tracks.length === 0) {
      return (
        <Trans
          i18nKey="PURCHASE_SUCESS_MODAL_EXTEND_DESC"
          values={{ song: selectedSong?.title }}
          components={{ bold: <strong /> }}
        />
      );
    }
    /* Default state */
    return <div>{t('PURCHASE_SUCESS_MODAL_DESC')}</div>;
  };

  // Getting modal title based on 2 scenarios default and enterprise
  const modalTitle = () => {
    return (
      <div>
        {enterpriseProfile.isEnterpriseProfile
          ? // Enterprise title
            t('ENTERPRISE_PURCHASE_SUCCESS_MODAL_TITLE')
          : // Default title
            t('PURCHASE_SUCCESS_MODAL_TITLE')}
      </div>
    );
  };

  return (
    <Modal
      isOpen={show}
      onClose={noop}
      analyticsModalType="purchase_successful_modal"
      trackEvent={trackModalView}
      containerStyles={{
        width: '608px',
        padding: '32px',
      }}
    >
      <ModalPurchaseSucessHeading>{modalTitle()}</ModalPurchaseSucessHeading>

      <ModalPurchaseSucessBody>{modalText()}</ModalPurchaseSucessBody>

      <FlexButtonWrapper>
        <ModalGoToDashboardButton
          setting="mtr"
          type="button"
          onClick={handleSuccessModal}
        >
          {t('PURCHASE_SUCESS_MODAL_GO_TO_DASHBOARD_BUTTON')}
        </ModalGoToDashboardButton>
      </FlexButtonWrapper>
    </Modal>
  );
};
